import sharedCss from '../shared/shared.styles';

export default (theme: Object) => ({
  screenContainer: {
    ...sharedCss.screenContainer,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  screenTitle: {
    ...sharedCss.screenTitle(theme),
    textAlign: 'center',
    marginBottom: 24,
  },
  forgotPassword: {
    fontSize: '0.85rem',
    color: theme.palette.primary.main,
  },
  controlButtons: {
    ...sharedCss.controlButtons,
    justifyContent: 'stretch',
    marginTop: 28,
    '& > *': {
      flex: 1,
    },
    '& > *:not(:first-child)': {
      marginLeft: 12,
    },
  },
  controlButton: {
    ...sharedCss.controlButton,
    marginLeft: 0,
    width: '100%',
  },
  emailInput: {
    width: '100%',
    marginBottom: 8,
  },
});
